export default __webpack_public_path__ + "static/media/RightButton.302630ce.svg";